// extracted by mini-css-extract-plugin
export default {"headerBar":"dK-z","pointsSection":"eK-z","goToDashboard":"fK-z"};